// extracted by mini-css-extract-plugin
export default {"works":"ListWork_works__bMhxh","workTitle":"ListWork_workTitle__eUX2k","vertical":"ListWork_vertical__YcDty"};